<div class="main-wrapper" [class.preview-active]="showFormPreview">
  <!-- ===== LEFT PANEL ===== -->
  <aside class="left-panel" [ngClass]="{ 'left-panel--collapsed': !showStepper }">
    <div class="gradient-overlay"></div>
    <div class="floating-blob blob-1"></div>
    <div class="floating-blob blob-2"></div>
    <div class="line-pattern"></div>

    <!-- Toggle Button — always visible -->
    <button class="stepper-toggle-btn" type="button" (click)="toggleStepper()"
      [title]="showStepper ? 'Collapse sidebar' : 'Expand sidebar'">
      <i class="bi bi-chevron-double-left toggle-icon" [class.rotated]="!showStepper"></i>
    </button>

    <!-- Mini Stepper — visible only when sidebar is collapsed -->
    <div class="mini-stepper" *ngIf="!showStepper">
      <div class="mini-step-item" *ngFor="let i of [0, 1, 2, 3, 4, 5]" [class.active]="activeStep === i"
        [class.completed]="isStepCompleted(i)" (click)="setStep(i)" [title]="
          [
            'Station & Type',
            'Firm Details',
            'Address Info',
            'Plant Operations',
            'Upload Documents',
            'Preview Application',
          ][i]
        ">
        <div class="mini-step-circle">
          <i *ngIf="isStepCompleted(i)" class="bi bi-check2"></i>
          <span *ngIf="!isStepCompleted(i)">{{ i + 1 }}</span>
        </div>
        <div class="mini-connector" *ngIf="i < 5"></div>
      </div>
    </div>

    <div class="left-content-wrap" [class.stepper-content--hidden]="!showStepper" [class.stepper-ready]="stepperReady">
      <div class="logo-area">
        <div class="logo-circle">
          <img src="TNPGCL_logo.png" alt="TNPGCL Logo" />
        </div>
        <div class="logo-labels">
          <!-- <span class="sub-label">TNPGCL &bull; GOVERNMENT OF TAMIL NADU</span> -->
          <h1 class="portal-title-text">Ash <span class="green-accent">Disposal Portal</span></h1>
        </div>
      </div>

      <!-- <p class="portal-subtitle">A digital platform for transparent allocation, monitoring and disposal of fly ash across Tamil Nadu power stations.</p> -->

      <!-- Stepper -->
      <div class="stepper">
        <div class="step-item" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)"
          (click)="setStep(0)">
          <div class="step-circle" [class.active]="activeStep === 0" [class.completed]="isStepCompleted(0)">
            <span *ngIf="!isStepCompleted(0)">1</span>
            <i *ngIf="isStepCompleted(0)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">STATION & TYPE</div>
            <div class="step-desc">Choose source power station</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(0)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 0 && !isStepCompleted(0)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)"
          (click)="setStep(1)">
          <div class="step-circle" [class.active]="activeStep === 1" [class.completed]="isStepCompleted(1)">
            <span *ngIf="!isStepCompleted(1)">2</span>
            <i *ngIf="isStepCompleted(1)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">FIRM DETAILS</div>
            <div class="step-desc">Business details & contact info</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(1)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 1 && !isStepCompleted(1)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)"
          (click)="setStep(2)">
          <div class="step-circle" [class.active]="activeStep === 2" [class.completed]="isStepCompleted(2)">
            <span *ngIf="!isStepCompleted(2)">3</span>
            <i *ngIf="isStepCompleted(2)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">ADDRESS INFO</div>
            <div class="step-desc">Plant & company office location</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(2)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 2 && !isStepCompleted(2)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)"
          (click)="setStep(3)">
          <div class="step-circle" [class.active]="activeStep === 3" [class.completed]="isStepCompleted(3)">
            <span *ngIf="!isStepCompleted(3)">4</span>
            <i *ngIf="isStepCompleted(3)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">PLANT OPERATIONS</div>
            <div class="step-desc">Capacity, products & machinery</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(3)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 3 && !isStepCompleted(3)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)"
          (click)="setStep(4)">
          <div class="step-circle" [class.active]="activeStep === 4" [class.completed]="isStepCompleted(4)">
            <span *ngIf="!isStepCompleted(4)">5</span>
            <i *ngIf="isStepCompleted(4)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">UPLOAD DOCUMENTS</div>
            <div class="step-desc">Verify supporting documents</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(4)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 4 && !isStepCompleted(4)">Active</span>
          </div>
        </div>

        <div class="step-item" [class.active]="activeStep === 5" [class.completed]="isStepCompleted(5)"
          (click)="setStep(5)">
          <div class="step-circle" [class.active]="activeStep === 5" [class.completed]="isStepCompleted(5)">
            <span *ngIf="!isStepCompleted(5)">6</span>
            <i *ngIf="isStepCompleted(5)" class="bi bi-check-lg"></i>
          </div>
          <div class="step-content">
            <div class="step-title">PREVIEW</div>
            <div class="step-desc">Review your details</div>
          </div>
          <div class="step-status-badge">
            <span class="badge completed-badge" *ngIf="isStepCompleted(5)">Done</span>
            <span class="badge active-badge" *ngIf="activeStep === 5 && !isStepCompleted(5)">Active</span>
          </div>
        </div>
      </div>

      <!-- <div class="feature-row">
        <div class="feature-card">
          <div class="fc-icon"><i class="bi bi-shield-check"></i></div>
          <div class="fc-text">Secure &amp; Transparent</div>
        </div>
        <div class="feature-card">
          <div class="fc-icon"><i class="bi bi-file-earmark-check"></i></div>
          <div class="fc-text">Digital Approvals</div>
        </div>
        <div class="feature-card">
          <div class="fc-icon"><i class="bi bi-graph-up-arrow"></i></div>
          <div class="fc-text">Real-time Tracking</div>
        </div>
      </div> -->

      <!-- <div class="stats-panel">
        <div class="stat-item">
          <i class="bi bi-buildings-fill"></i>
          <div class="stat-num">250+</div>
          <div class="stat-label">Registered Industries</div>
        </div>
        <div class="stat-item">
          <i class="bi bi-truck"></i>
          <div class="stat-num green-num">15,000+</div>
          <div class="stat-label">Fly Ash Allocations</div>
        </div>
        <div class="stat-item">
          <i class="bi bi-person-fill"></i>
          <div class="stat-num">8,500+</div>
          <div class="stat-label">Active Users</div>
        </div>
      </div> -->
    </div>
  </aside>

  <!-- ===== RIGHT PANEL ===== -->
  <main class="right-panel">
    <!-- ===== HERO BANNER ===== -->
    <div class="hero-banner" *ngIf="!showFormPreview">
      <div class="hero-banner-inner">
        <!-- Left Text Content -->
        <div class="hero-text-content">
          <div class="hero-badge">
            <span class="hero-badge-dot"></span>
            Tamil Nadu Power Generation Corporation Limited
          </div>
          <h1 class="hero-title">
            Ash Disposal <span class="hero-title-highlight">Registration</span>
          </h1>
          <p class="hero-subtitle">
            Register your organization and manage ash allocation<br />digitally through the TNPGCL
            Ash Portal.
          </p>
          <div class="hero-feature-row">
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-shield-check"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Secure</span>
                <span class="hero-feature-sub">Registration</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-check2-square"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Online</span>
                <span class="hero-feature-sub">Verification</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-lightning-charge"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">Fast</span>
                <span class="hero-feature-sub">Approval</span>
              </div>
            </div>
            <div class="hero-feature">
              <div class="hero-feature-icon"><i class="bi bi-patch-check"></i></div>
              <div class="hero-feature-text">
                <span class="hero-feature-label">100%</span>
                <span class="hero-feature-sub">Digital Process</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Government Logo Badge -->
        <div class="hero-eco-badge">
          <img src="TNPGCL_logo.png" alt="TNPGCL Government Logo" class="hero-gov-logo" />
        </div>
      </div>
    </div>
    <!-- ===== END HERO BANNER ===== -->

    <div class="form-card">
      <div class="form-card-actions" *ngIf="!showFormPreview">
        <button type="button" class="btn-resume-draft" (click)="onResumeDraft()" [disabled]="isLoadingDraft">
          <span *ngIf="isLoadingDraft" class="spinner-border spinner-border-sm me-1" role="status"
            aria-hidden="true"></span>
          <i *ngIf="!isLoadingDraft" class="bi bi-arrow-counterclockwise"></i>
          {{ isLoadingDraft ? 'Loading Draft...' : 'Resume Draft' }}
        </button>
      </div>

      <!-- Progress bar — flush top of card, no inner box -->
      <div class="form-progress-bar">
        <div class="form-progress-fill" [style.width.%]="getProgressPercent()"></div>
      </div>

      <!-- Registration Form -->
      <form [formGroup]="registerForm" (ngSubmit)="handleSubmit()" novalidate>
        <!-- Step 1: Station & Category (activeStep === 0) -->
        <div class="form-step" *ngIf="activeStep === 0">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-building-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Power Station Details</h3>
          </div>
          <p class="section-desc">Select power station</p>

          <div class="row row-gap g-3">
            <!-- Mobile number input (Exisitng phone no avaible check in the database) -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Mobile Number <span class="required-star">*</span></label>
              <div class="phone-group">
                <div class="phone-prefix">
                  <span class="flag-emoji">🇮🇳</span>
                  <span>+91</span>
                </div>
                <input type="tel" class="form-control phone-input" placeholder="Enter 10-digit mobile number"
                  formControlName="mobileNumber" maxlength="10"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57;" />
              </div>
              <div *ngIf="
                  registerForm.get('mobileNumber')?.touched ||
                  (registerForm.get('mobileNumber')?.dirty &&
                    registerForm.get('mobileNumber')?.value?.length === 10)
                " class="mt-1" style="font-size: 11.5px; font-weight: 500">
                <div *ngIf="mobileCheckStatus === 'checking'" class="text-primary">
                  <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                  Checking mobile number...
                </div>
                <div *ngIf="mobileCheckStatus === 'valid'" class="text-success">
                  <i class="bi bi-check-circle-fill"></i> Mobile number is valid.
                </div>
                <div *ngIf="
                    mobileCheckStatus === 'exists' ||
                    registerForm.get('mobileNumber')?.errors?.['alreadyRegistered']
                  " class="text-danger">
                  <i class="bi bi-exclamation-circle-fill"></i>
                  {{
                  mobileCheckErrorMsg ||
                  'This mobile number is already
                  registered!'
                  }}
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.errors?.['required'] &&
                    mobileCheckStatus !== 'exists'
                  " class="text-danger">
                  Mobile number is required.
                </div>
                <div *ngIf="
                    registerForm.get('mobileNumber')?.errors?.['pattern'] &&
                    mobileCheckStatus !== 'exists'
                  " class="text-danger">
                  Must be a valid 10-digit number.
                </div>
              </div>

              <div *ngIf="canGenerateMobileOtp" class="mobile-otp-actions mt-2">
                <button type="button" class="btn-generate-otp" (click)="onGenerateMobileOtp()"
                  [disabled]="mobileOtpGenerating">
                  <span *ngIf="!mobileOtpGenerating">
                    <i class="bi bi-shield-lock"></i> Generate OTP
                  </span>
                  <span *ngIf="mobileOtpGenerating">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Generating OTP...
                  </span>
                </button>
              </div>

              <div *ngIf="mobileOtpSent && !mobileOtpVerified" class="mobile-otp-section mt-3"
                [formGroup]="mobileOtpForm">
                <div *ngIf="mobileOtpSuccess" class="mobile-otp-success">
                  <i class="bi bi-check-circle-fill"></i> {{ mobileOtpSuccess }}
                </div>

                <button type="button" class="btn-change-mobile" (click)="changeMobileNumber()">
                  <i class="bi bi-arrow-left"></i> Change mobile number
                </button>

                <label class="form-label mt-2">Enter 4-Digit OTP</label>
                <div class="mobile-otp-input-group" (paste)="onMobileOtpPaste($event)">
                  <input *ngFor="let field of mobileOtpFields; let i = index" [id]="field" type="text"
                    inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                    autocomplete="one-time-code" (input)="onMobileOtpInput($event, field, i < 3 ? 'otp' + (i + 2) : '')"
                    (keydown)="onMobileOtpKeydown($event, field, i > 0 ? 'otp' + i : '')" />
                </div>
                <div *ngIf="mobileOtpForm.touched && !isMobileOtpComplete" class="text-danger mt-1"
                  style="font-size: 11.5px; font-weight: 500">
                  OTP is required. Please enter all 4 digits.
                </div>

                <div class="mobile-resend-row mt-2">
                  <span>Didn't receive the code?</span>
                  <button type="button" class="btn-resend-mobile-otp" (click)="onResendMobileOtp()" [disabled]="
                      mobileOtpResendCountdown > 0 || mobileOtpResendLoading || mobileOtpVerifying
                    ">
                    <span *ngIf="mobileOtpResendLoading">Resending...</span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown > 0">
                      Resend OTP in {{ mobileOtpResendCountdown }}s
                    </span>
                    <span *ngIf="!mobileOtpResendLoading && mobileOtpResendCountdown === 0">
                      Resend OTP
                    </span>
                  </button>
                </div>

                <div *ngIf="mobileOtpError" class="mobile-otp-error mt-2">
                  <i class="bi bi-exclamation-circle-fill"></i> {{ mobileOtpError }}
                </div>

                <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyMobileOtp()"
                  [disabled]="mobileOtpVerifying || !isMobileOtpComplete">
                  <span *ngIf="!mobileOtpVerifying">
                    <i class="bi bi-shield-check"></i> Verify OTP
                  </span>
                  <span *ngIf="mobileOtpVerifying">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Verifying...
                  </span>
                </button>
              </div>

              <div *ngIf="mobileOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                <i class="bi bi-patch-check-fill"></i> Mobile number verified successfully.
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Power Station <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-building input-icon"></i>
                <select class="form-select" formControlName="station" style="padding-left: 40px">
                  <option value="" disabled selected>Select Power Station</option>
                  <option *ngFor="let station of powerStations" [value]="station.id">
                    {{ station.name }}
                  </option>
                </select>
              </div>
              <div *ngIf="registerForm.get('station')?.touched && registerForm.get('station')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('station')?.errors?.['required']">Power station is required.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 2: Firm Details & Contact (activeStep === 1) -->
        <div class="form-step" *ngIf="activeStep === 1">
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-person-vcard-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Organizational Details</h3>
          </div>
          <p class="section-desc">Provide your organization details.</p>

          <!-- Row 1 -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-6">
              <label class="form-label">Organization Name <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-buildings input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter organization name"
                  formControlName="firmName" />
              </div>
              <div *ngIf="
                  registerForm.get('firmName')?.touched && registerForm.get('firmName')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Organization name is required.</span>
              </div>
            </div>
            <div class="col-md-6">
              <label class="form-label">Email ID <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-envelope input-icon"></i>
                <input type="email" class="form-control" placeholder="Enter email address"
                  formControlName="emailAddress" />
              </div>
              <div *ngIf="
                  registerForm.get('emailAddress')?.touched &&
                  registerForm.get('emailAddress')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('emailAddress')?.errors?.['required']">Email address is required.</span>
                <span
                  *ngIf="registerForm.get('emailAddress')?.errors?.['email'] || registerForm.get('emailAddress')?.errors?.['pattern']">Please
                  enter a valid email address.</span>
              </div>
              <div *ngIf="
                  registerForm.get('emailAddress')?.valid &&
                  registerForm.get('emailAddress')?.value &&
                  !emailOtpVerified
                " class="text-success mt-1" style="font-size: 11.5px; font-weight: 500">
                <i class="bi bi-check-circle-fill"></i> Email format is valid.
              </div>

              <div *ngIf="canGenerateEmailOtp" class="mobile-otp-actions mt-2">
                <button type="button" class="btn-generate-otp" (click)="onGenerateEmailOtp()"
                  [disabled]="emailOtpGenerating">
                  <span *ngIf="!emailOtpGenerating">
                    <i class="bi bi-shield-lock"></i> Generate OTP
                  </span>
                  <span *ngIf="emailOtpGenerating">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Generating OTP...
                  </span>
                </button>
              </div>

              <div *ngIf="emailOtpSent && !emailOtpVerified" class="mobile-otp-section mt-3" [formGroup]="emailOtpForm">
                <div *ngIf="emailOtpSuccess" class="mobile-otp-success">
                  <i class="bi bi-check-circle-fill"></i> {{ emailOtpSuccess }}
                </div>

                <button type="button" class="btn-change-mobile" (click)="changeEmailAddress()">
                  <i class="bi bi-arrow-left"></i> Change email address
                </button>

                <label class="form-label mt-2">Enter 4-Digit OTP</label>
                <div class="mobile-otp-input-group" (paste)="onEmailOtpPaste($event)">
                  <input *ngFor="let field of emailOtpFields; let i = index" [id]="field" type="text"
                    inputmode="numeric" maxlength="1" class="mobile-otp-input" [formControlName]="field"
                    autocomplete="one-time-code"
                    (input)="onEmailOtpInput($event, field, i < 3 ? 'emailOtp' + (i + 2) : '')"
                    (keydown)="onEmailOtpKeydown($event, field, i > 0 ? 'emailOtp' + i : '')" />
                </div>
                <div *ngIf="emailOtpForm.touched && !isEmailOtpComplete" class="text-danger mt-1"
                  style="font-size: 11.5px; font-weight: 500">
                  OTP is required. Please enter all 4 digits.
                </div>

                <div class="mobile-resend-row mt-2">
                  <span>Didn't receive the code?</span>
                  <button type="button" class="btn-resend-mobile-otp" (click)="onResendEmailOtp()" [disabled]="
                      emailOtpResendCountdown > 0 || emailOtpResendLoading || emailOtpVerifying
                    ">
                    <span *ngIf="emailOtpResendLoading">Resending...</span>
                    <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown > 0">
                      Resend OTP in {{ emailOtpResendCountdown }}s
                    </span>
                    <span *ngIf="!emailOtpResendLoading && emailOtpResendCountdown === 0">
                      Resend OTP
                    </span>
                  </button>
                </div>

                <div *ngIf="emailOtpError" class="mobile-otp-error mt-2">
                  <i class="bi bi-exclamation-circle-fill"></i> {{ emailOtpError }}
                </div>

                <button type="button" class="btn-verify-mobile-otp mt-2" (click)="onVerifyEmailOtp()"
                  [disabled]="emailOtpVerifying || !isEmailOtpComplete">
                  <span *ngIf="!emailOtpVerifying">
                    <i class="bi bi-shield-check"></i> Verify OTP
                  </span>
                  <span *ngIf="emailOtpVerifying">
                    <span class="spinner-border spinner-border-sm me-1" role="status"></span>
                    Verifying...
                  </span>
                </button>
              </div>

              <div *ngIf="emailOtpVerified" class="text-success mt-2" style="font-size: 11.5px; font-weight: 600">
                <i class="bi bi-patch-check-fill"></i> Email verified successfully.
              </div>
            </div>
          </div>

          <!-- Row 2 -->

          <!-- Row 3 -->
          <div class="row row-gap mb-3">
            <div class="col-md-6 mb-3">
              <label class="form-label">PAN Number <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-card-heading input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter 10-character PAN number"
                  formControlName="panNumber" maxlength="10" style="text-transform: uppercase" />
              </div>
              <div *ngIf="
                  registerForm.get('panNumber')?.touched && registerForm.get('panNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('panNumber')?.errors?.['required']">PAN number is required.</span>
                <span *ngIf="registerForm.get('panNumber')?.errors?.['pattern']">Please enter a valid PAN format (e.g.
                  ABCDE1234F).</span>
              </div>
              <div class="mt-3">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['panCard']"
                  (click)="openUploadPopup('panCard')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['panCard']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['panCard']"></i>
                    </div>
                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        PAN Card <span class="required-star">*</span>
                      </div>
                      <div class="mini-upload-hint" [class.success]="uploadedFiles['panCard']">
                        <span *ngIf="uploadedFiles['panCard']">
                          Uploaded:
                          {{
                          (uploadedFiles['panCard']?.name?.length || 0) > 20
                          ? (uploadedFiles['panCard']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['panCard']?.name
                          }}
                        </span>
                        <span *ngIf="!uploadedFiles['panCard']">PDF, Image (Max 2MB)</span>
                      </div>
                    </div>
                  </div>
                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['panCard']"
                    [class.bi-chevron-right]="!uploadedFiles['panCard']" [class.done]="uploadedFiles['panCard']"></i>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <label class="form-label">GST Number <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-receipt input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter 15-character GST number"
                  formControlName="gstNumber" maxlength="15" style="text-transform: uppercase" />
              </div>
              <div *ngIf="
                  registerForm.get('gstNumber')?.touched && registerForm.get('gstNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('gstNumber')?.errors?.['required']">GST number is required.</span>
                <span *ngIf="registerForm.get('gstNumber')?.errors?.['pattern']">Please enter a valid GST format (e.g.
                  33ABCDE1234F1Z5).</span>
              </div>
              <div class="mt-3">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['gstCertificate']"
                  (click)="openUploadPopup('gstCertificate')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['gstCertificate']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['gstCertificate']"></i>
                    </div>
                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        GST Certificate <span class="required-star">*</span>
                      </div>
                      <div class="mini-upload-hint" [class.success]="uploadedFiles['gstCertificate']">
                        <span *ngIf="uploadedFiles['gstCertificate']">
                          Uploaded:
                          {{
                          (uploadedFiles['gstCertificate']?.name?.length || 0) > 20
                          ? (uploadedFiles['gstCertificate']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['gstCertificate']?.name
                          }}
                        </span>
                        <span *ngIf="!uploadedFiles['gstCertificate']">PDF, Image (Max 2MB)</span>
                      </div>
                    </div>
                  </div>
                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['gstCertificate']"
                    [class.bi-chevron-right]="!uploadedFiles['gstCertificate']"
                    [class.done]="uploadedFiles['gstCertificate']"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- Row 4 -->
          <div class="row g-3 mb-3">
            <!-- Certificate Type -->
            <div class="col-md-4">
              <label class="form-label">
                MSME / Udyam Certificate Type
                <span class="required-star">*</span>
              </label>

              <div class="input-wrapper">
                <i class="bi bi-file-earmark-check input-icon"></i>
                <select class="form-select" formControlName="msmeCertificateType" style="padding-left: 40px">
                  <option value="" disabled selected>MSME Udyam Certificate Type</option>
                  <option value="Micro">Micro</option>
                  <option value="Small">Small</option>
                  <option value="Medium">Medium</option>
                </select>
              </div>

              <div *ngIf="
                  registerForm.get('msmeCertificateType')?.touched &&
                  registerForm.get('msmeCertificateType')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                MSE Certificate Type is required.
              </div>
            </div>

            <!-- Certificate Number -->
            <div class="col-md-4">
              <label class="form-label">
                MSME/Udyam Certificate Number
                <span class="required-star">*</span>
              </label>

              <div class="input-wrapper">
                <i class="bi bi-bookmark-star input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter MSME Udyam number"
                  formControlName="msmeRegistrationNumber" />
              </div>

              <div *ngIf="
                  registerForm.get('msmeRegistrationNumber')?.touched &&
                  registerForm.get('msmeRegistrationNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('msmeRegistrationNumber')?.errors?.['required']">
                  MSME/Udyam Certificate Number is required.
                </span>

                <span *ngIf="registerForm.get('msmeRegistrationNumber')?.errors?.['pattern']">
                  Please enter a valid Udyam format (e.g. UDYAM-TN-12-1234567).
                </span>
              </div>
            </div>

            <!-- Certificate Upload -->
            <div class="col-md-4">
              <div class="mini-upload-card" [class.uploaded]="uploadedFiles['msmeCertificate']"
                (click)="openUploadPopup('msmeCertificate')">
                <div class="mini-upload-left">
                  <div class="mini-upload-icon">
                    <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['msmeCertificate']"
                      [class.bi-cloud-arrow-up-fill]="!uploadedFiles['msmeCertificate']"></i>
                  </div>

                  <div class="mini-upload-info">
                    <div class="mini-upload-title">Upload udyam Certificate</div>

                    <div class="mini-upload-hint" [class.success]="uploadedFiles['msmeCertificate']">
                      <span *ngIf="uploadedFiles['msmeCertificate']">
                        Uploaded:
                        {{
                        (uploadedFiles['msmeCertificate']?.name?.length || 0) > 20
                        ? (uploadedFiles['msmeCertificate']?.name | slice: 0 : 18) + '...'
                        : uploadedFiles['msmeCertificate']?.name
                        }}
                      </span>

                      <span *ngIf="!uploadedFiles['msmeCertificate']"> PDF, Image (Max 2MB) </span>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="
                  registerForm.get('msmeRegistrationNumber')?.touched &&
                  !uploadedFiles['msmeCertificate']
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                MSME/Udyam Certificate is required.
              </div>
            </div>
          </div>

          <!-- tariff details -->

          <div class="row g-3 mb-3">
            <!-- Tariff Category -->
            <div class="col-md-4">
              <label class="form-label">
                TNEB Tariff Category <span class="required-star">*</span>
              </label>

              <div class="input-wrapper">
                <i class="bi bi-tags input-icon"></i>
                <select class="form-select" formControlName="tariff" style="padding-left: 40px">
                  <option value="" disabled selected>Select TNEB Tariff Category</option>
                  <option *ngFor="let tf of tariff" [value]="tf.id">
                    {{ tf.name }}
                  </option>
                </select>
              </div>

              <div *ngIf="registerForm.get('tariff')?.touched && registerForm.get('tariff')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                Tariff category is required.
              </div>
            </div>

            <!-- EB Service Connection Number -->
            <div class="col-md-4">
              <label class="form-label">
                TNEB Service Connection Number
                <span class="required-star">*</span>
              </label>

              <div class="input-wrapper w-100 d-block">
                <i class="bi bi-lightning input-icon"></i>
                <input type="text" class="form-control" placeholder="Enter 12-digit EB service connection number"
                  formControlName="tnpgclScNumber" maxlength="12" />
              </div>

              <div *ngIf="
                  registerForm.get('tnpgclScNumber')?.touched &&
                  registerForm.get('tnpgclScNumber')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('tnpgclScNumber')?.errors?.['required']">
                  EB service SC number is required.
                </span>

                <span *ngIf="registerForm.get('tnpgclScNumber')?.errors?.['pattern']">
                  Must be exactly a 12-digit connection number.
                </span>
              </div>
            </div>

            <!-- Upload Document -->
            <div class="col-md-4">
              <div class="custom-tooltip-wrapper w-100 d-block">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['previousEbBill']"
                  (click)="openUploadPopup('previousEbBill')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['previousEbBill']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['previousEbBill']"></i>
                    </div>

                    <div class="mini-upload-info">
                      <div class="mini-upload-title">TNEB Bill Status <span class="required-star">*</span></div>

                      <div class="mini-upload-hint" [class.success]="uploadedFiles['previousEbBill']">
                        <span *ngIf="uploadedFiles['previousEbBill']">
                          Uploaded:
                          {{
                          (uploadedFiles['previousEbBill']?.name?.length || 0) > 20
                          ? (uploadedFiles['previousEbBill']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['previousEbBill']?.name
                          }}
                        </span>

                        <span *ngIf="!uploadedFiles['previousEbBill']"> PDF, Image (Max 2MB) </span>
                      </div>
                    </div>
                  </div>

                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['previousEbBill']"
                    [class.bi-chevron-right]="!uploadedFiles['previousEbBill']"
                    [class.done]="uploadedFiles['previousEbBill']"></i>
                </div>
                <span class="custom-tooltip-text tooltip-left">
                  Please upload your electricity bill history.
                </span>
              </div>

              <div class="mt-2">
                <small class="text-muted d-flex align-items-center gap-1">
                  Bill Status
                  <a href="https://www.tnebltd.gov.in/BillStatus/billstatus.xhtml" target="_blank"
                    class="fw-semibold text-primary text-decoration-none">
                    Click Here
                    <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </small>
              </div>
            </div>
          </div>

        </div>

        <!-- Step 3: Location & Addresses (activeStep === 2) -->
        <div class="form-step" *ngIf="activeStep === 2">
          <!-- Section 1: Company Registered Address -->
          <div class="section-title d-flex align-items-center gap-2 mb-4">
            <i class="bi bi-geo-alt-fill"></i>
            <h3 class="mb-0 fw-semibold text-uppercase">Plant Address Details</h3>
          </div>
          <p class="section-desc">Provide details of your company registered office.</p>

          <!-- Company Registered Address Row 1 -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-4">
              <label class="form-label">Door No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-house input-icon"></i>
                <input type="text" class="form-control" placeholder="Door or building number"
                  formControlName="doorNo" />
              </div>
              <div *ngIf="registerForm.get('doorNo')?.touched && registerForm.get('doorNo')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Door number is required.</span>
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Survey Field No <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-hash input-icon"></i>
                <input type="text" class="form-control" placeholder="Survey field number"
                  formControlName="surveyFieldNo" />
              </div>
              <div *ngIf="
                  registerForm.get('surveyFieldNo')?.touched &&
                  registerForm.get('surveyFieldNo')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Survey/field number is required.</span>
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Street / Location <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-signpost-split input-icon"></i>
                <input type="text" class="form-control" placeholder="Street name and locality"
                  formControlName="streetLocation" />
              </div>
              <div *ngIf="
                  registerForm.get('streetLocation')?.touched &&
                  registerForm.get('streetLocation')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Street name is required.</span>
              </div>
            </div>
          </div>

          <!-- Company Registered Address Row 2 -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-3">
              <label class="form-label"> State <span class="required-star">*</span> </label>

              <input type="hidden" formControlName="state" />

              <div class="input-wrapper">
                <i class="bi bi-globe input-icon"></i>

                <input type="text" class="form-control" value="Tamil Nadu" readonly style="padding-left: 40px" />
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">District <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-map input-icon"></i>
                <select class="form-select" formControlName="district" style="padding-left: 40px">
                  <option value="" disabled selected>Select District</option>
                  <option *ngFor="let dist of districts" [value]="dist.id">
                    {{ dist.name || dist }}
                  </option>
                </select>
              </div>
              <div *ngIf="
                  registerForm.get('district')?.touched && registerForm.get('district')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>District is required.</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Taluk <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo input-icon"></i>
                <select class="form-select" formControlName="taluk" style="padding-left: 40px">
                  <option value="" disabled selected>Select Taluk</option>
                  <option *ngFor="let tk of taluks" [value]="tk.id">
                    {{ tk.name || tk }}
                  </option>
                </select>
              </div>
              <div *ngIf="registerForm.get('taluk')?.touched && registerForm.get('taluk')?.invalid" class="text-danger"
                style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Taluk is required.</span>
              </div>
            </div>

            <div class="col-md-3">
              <label class="form-label">Village <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-geo-alt input-icon"></i>
                <select class="form-select" formControlName="village" style="padding-left: 40px">
                  <option value="" disabled selected>Select Village</option>
                  <option *ngFor="let vil of villages" [value]="vil.id">
                    {{ vil.name || vil }}
                  </option>
                </select>
              </div>
              <div *ngIf="registerForm.get('village')?.touched && registerForm.get('village')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Village is required.</span>
              </div>
            </div>
          </div>

          <!-- Company Registered Address Row 3 -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-4">
              <label class="form-label">Pincode <span class="required-star">*</span></label>
              <div class="input-wrapper">
                <i class="bi bi-pin-angle input-icon"></i>
                <input type="text" class="form-control" placeholder="6-digit pincode" formControlName="pincode"
                  maxlength="6" />
              </div>
              <div *ngIf="registerForm.get('pincode')?.touched && registerForm.get('pincode')?.invalid"
                class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('pincode')?.errors?.['required']">Pincode is required.</span>
                <span *ngIf="registerForm.get('pincode')?.errors?.['pattern']">Must be exactly a 6-digit postal
                  code.</span>
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Latitude</label>
              <div class="input-wrapper">
                <i class="bi bi-compass input-icon"></i>
                <input type="text" class="form-control" placeholder="Select location on map" formControlName="latitude"
                  readonly />
              </div>
            </div>

            <div class="col-md-4">
              <label class="form-label">Longitude</label>
              <div class="input-wrapper">
                <i class="bi bi-compass input-icon"></i>
                <input type="text" class="form-control" placeholder="Select location on map" formControlName="longitude"
                  readonly />
              </div>
            </div>
          </div>

          <div class="location-map-section mb-3">
            <label class="form-label d-flex align-items-center gap-2 mb-1">
              <i class="bi bi-map"></i> Select Plant Location on Map
            </label>
            <p class="map-selection-hint">
              Search for a location, click on the map to place a marker, or drag the marker to
              adjust. Latitude and longitude will be filled automatically.
            </p>
            <div class="input-wrapper location-search-wrapper mb-2">
              <i class="bi bi-search input-icon"></i>
              <input #plantLocationSearch type="text" class="form-control location-search-input"
                placeholder="Search for a location or address" autocomplete="off" />
            </div>
            <div #plantMapContainer class="location-map-container" role="application" aria-label="Plant location map">
            </div>
            <div *ngIf="locationMapError" class="text-danger"
              style="font-size: 11.5px; margin-top: 8px; font-weight: 500">
              {{ locationMapError }}
            </div>
          </div>

          <button type="button" class="btn-gps mb-4" (click)="detectLocation('plant')">
            <i class="bi bi-geo-alt-fill"></i> Auto-Detect Coordinates (GPS)
          </button>

          <div class="row g-3 mt-1 mb-3">
            <div class="col-md-6">
              <label class="form-label d-flex align-items-center gap-2 mb-0">
                PLANT PHOTO WITH GPS DETAILS
                <span class="required-star">*</span>

                <span class="custom-tooltip-wrapper">
                  <i class="bi bi-info-circle-fill text-primary" style="cursor: pointer"></i>
                  <span class="custom-tooltip-text">
                    Upload a GPS Map Camera photo with location details.
                  </span>
                </span>
              </label>

              <div class="mt-2">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['gpsMapCameraPhoto']"
                  (click)="openUploadPopup('gpsMapCameraPhoto')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['gpsMapCameraPhoto']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['gpsMapCameraPhoto']"></i>
                    </div>

                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        PLANT PHOTO WITH GPS DETAILS
                        <span class="required-star">*</span>
                      </div>

                      <div class="mini-upload-hint" [class.success]="uploadedFiles['gpsMapCameraPhoto']">
                        <span *ngIf="uploadedFiles['gpsMapCameraPhoto']">
                          Uploaded:
                          {{
                          (uploadedFiles['gpsMapCameraPhoto']?.name?.length || 0) > 20
                          ? (uploadedFiles['gpsMapCameraPhoto']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['gpsMapCameraPhoto']?.name
                          }}
                        </span>

                        <span *ngIf="!uploadedFiles['gpsMapCameraPhoto']">
                          Add the Plant Address Photo
                        </span>
                      </div>
                    </div>
                  </div>

                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['gpsMapCameraPhoto']"
                    [class.bi-chevron-right]="!uploadedFiles['gpsMapCameraPhoto']"
                    [class.done]="uploadedFiles['gpsMapCameraPhoto']"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- YES/NO Option for Company Registered Address Same as Plant Address -->
          <div class="row mb-4 same-address-box py-3 border-top border-bottom"
            style="background-color: #f8fafc; border-radius: 6px">
            <div class="col-12 px-3">
              <label class="form-label fw-semibold" style="color: #475569; font-size: 14px">Company Registered Address
                same as Plant Address?</label>
              <div class="d-flex gap-4 align-items-center mt-2">
                <div class="form-check custom-radio">
                  <input type="radio" id="sameAsPlantAddressYes" [value]="true" formControlName="sameAsPlantAddress"
                    class="form-check-input" />
                  <label class="form-check-label ms-1" for="sameAsPlantAddressYes"
                    style="font-weight: 500; cursor: pointer">YES</label>
                </div>
                <div class="form-check custom-radio">
                  <input type="radio" id="sameAsPlantAddressNo" [value]="false" formControlName="sameAsPlantAddress"
                    class="form-check-input" />
                  <label class="form-check-label ms-1" for="sameAsPlantAddressNo"
                    style="font-weight: 500; cursor: pointer">NO</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 2: Plant Address (Hidden/Opened based on sameAsPlantAddress option) -->
          <div *ngIf="!registerForm.get('sameAsPlantAddress')?.value" class="company-address-section mb-4">
            <div class="section-title d-flex align-items-center gap-2 mb-4">
              <i class="bi bi-building-fill-add"></i>
              <h3 class="mb-0 fw-semibold text-uppercase">Company Registered Address Details</h3>
            </div>
            <p class="section-desc">Provide your plant address location details.</p>

            <!-- Plant Address Row 1 -->
            <div class="row row-gap g-3 mb-3">
              <div class="col-md-4">
                <label class="form-label">Door No <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-house input-icon"></i>
                  <input type="text" class="form-control" placeholder="Door or building number"
                    formControlName="companyDoorNo" />
                </div>
                <div *ngIf="
                    registerForm.get('companyDoorNo')?.touched &&
                    registerForm.get('companyDoorNo')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Door number is required.</span>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Survey / Field No <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-hash input-icon"></i>
                  <input type="text" class="form-control" placeholder="Survey field number"
                    formControlName="companySurveyFieldNo" />
                </div>
                <div *ngIf="
                    registerForm.get('companySurveyFieldNo')?.touched &&
                    registerForm.get('companySurveyFieldNo')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Survey number is required.</span>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Street / Location <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-signpost-split input-icon"></i>
                  <input type="text" class="form-control" placeholder="Street and locality"
                    formControlName="companyStreetLocation" />
                </div>
                <div *ngIf="
                    registerForm.get('companyStreetLocation')?.touched &&
                    registerForm.get('companyStreetLocation')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Street name is required.</span>
                </div>
              </div>
            </div>

            <!-- Plant Address Row 2 -->
            <div class="row row-gap g-3 mb-3">
              <div class="col-md-3">
                <label class="form-label">State <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-globe input-icon"></i>
                  <select class="form-select" formControlName="companyState" style="
                      padding-left: 40px;
                      appearance: none;
                      -webkit-appearance: none;
                      -moz-appearance: none;
                      background-image: none;
                      pointer-events: none;
                    ">
                    <option value="" disabled>Select State</option>
                    <option *ngFor="let st of states" [value]="st.id">
                      {{ st.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">District <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-map input-icon"></i>
                  <select class="form-select" formControlName="companyDistrict" style="padding-left: 40px">
                    <option value="" disabled selected>Select District</option>
                    <option *ngFor="let dist of companyDistricts" [value]="dist.id">
                      {{ dist.name || dist }}
                    </option>
                  </select>
                </div>
                <div *ngIf="
                    registerForm.get('companyDistrict')?.touched &&
                    registerForm.get('companyDistrict')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>District is required.</span>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Taluk <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-geo input-icon"></i>
                  <select class="form-select" formControlName="companyTaluk" style="padding-left: 40px">
                    <option value="" disabled selected>Select Taluk</option>
                    <option *ngFor="let tk of companyTaluks" [value]="tk.id">
                      {{ tk.name || tk }}
                    </option>
                  </select>
                </div>
                <div *ngIf="
                    registerForm.get('companyTaluk')?.touched &&
                    registerForm.get('companyTaluk')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Taluk is required.</span>
                </div>
              </div>

              <div class="col-md-3">
                <label class="form-label">Village <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-geo-alt input-icon"></i>
                  <select class="form-select" formControlName="companyVillage" style="padding-left: 40px">
                    <option value="" disabled selected>Select Village</option>
                    <option *ngFor="let vil of companyVillages" [value]="vil.id">
                      {{ vil.name || vil }}
                    </option>
                  </select>
                </div>
                <div *ngIf="
                    registerForm.get('companyVillage')?.touched &&
                    registerForm.get('companyVillage')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Village is required.</span>
                </div>
              </div>
            </div>

            <!-- Plant Address Row 3 -->
            <div class="row row-gap g-3">
              <div class="col-md-4">
                <label class="form-label">Pincode <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-pin-angle input-icon"></i>
                  <input type="text" class="form-control" placeholder="6-digit pincode" formControlName="companyPincode"
                    maxlength="6" />
                </div>
                <div *ngIf="
                    registerForm.get('companyPincode')?.touched &&
                    registerForm.get('companyPincode')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span *ngIf="registerForm.get('companyPincode')?.errors?.['required']">Pincode is required.</span>
                  <span *ngIf="registerForm.get('companyPincode')?.errors?.['pattern']">Must be a 6-digit postal
                    code.</span>
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Latitude</label>
                <div class="input-wrapper">
                  <i class="bi bi-compass input-icon"></i>
                  <input type="text" class="form-control" placeholder="Select location on map"
                    formControlName="companyLatitude" readonly />
                </div>
              </div>

              <div class="col-md-4">
                <label class="form-label">Longitude</label>
                <div class="input-wrapper">
                  <i class="bi bi-compass input-icon"></i>
                  <input type="text" class="form-control" placeholder="Select location on map"
                    formControlName="companyLongitude" readonly />
                </div>
              </div>
            </div>

            <div class="location-map-section mb-3 mt-3">
              <label class="form-label d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-map"></i> Select Company Location on Map
              </label>
              <p class="map-selection-hint">
                Search for a location, click on the map to place a marker, or drag the marker to
                adjust. Latitude and longitude will be filled automatically.
              </p>
              <div class="input-wrapper location-search-wrapper mb-2">
                <i class="bi bi-search input-icon"></i>
                <input #companyLocationSearch type="text" class="form-control location-search-input"
                  placeholder="Search for a company location or address" autocomplete="off" />
              </div>
              <div #companyMapContainer class="location-map-container" role="application"
                aria-label="Company location map"></div>
              <div *ngIf="locationMapError" class="text-danger"
                style="font-size: 11.5px; margin-top: 8px; font-weight: 500">
                {{ locationMapError }}
              </div>
            </div>

            <button type="button" class="btn-gps mt-4" (click)="detectLocation('company')">
              <i class="bi bi-geo-alt-fill"></i> Auto-Detect Coordinates (GPS)
            </button>
          </div>

          <!-- Plant Photo Upload (Always Visible at bottom of Step 3) -->
        </div>

        <!-- Step 4: Plant & Machinery Details and Product Manufacturing (activeStep === 3) -->
        <div class="form-step" *ngIf="activeStep === 3">

          <p class="section-desc">
            Provide information about your industry product types and needed ash requirements.
          </p>

          <!-- Row 1: Plant Machinery & Ash Unloading -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-6">
              <label class="form-label">Plant & Machinery Availability Details <span
                  class="required-star">*</span></label>
              <div class="form-control d-flex flex-wrap gap-2 align-items-center"
                style="min-height: 48px; height: auto; padding: 6px 12px; cursor: text; border-radius: 8px"
                [class.is-invalid]="
                  registerForm.get('plantMachinery')?.invalid &&
                  registerForm.get('plantMachinery')?.touched
                " (click)="machineryInput.focus()">
                <span class="badge bg-primary d-flex align-items-center gap-1 px-2 py-1"
                  *ngFor="let tag of plantMachineriesTags; let i = index"
                  style="font-size: 13px; max-width: 100%; word-break: break-all; white-space: normal; text-align: left;">
                  {{ tag }}
                  <i class="bi bi-x-circle-fill flex-shrink-0"
                    style="cursor: pointer; margin-left: 4px; font-size: 12px"
                    (click)="removeMachineryTag(i); $event.stopPropagation()"></i>
                </span>
                <input type="text" #machineryInput class="border-0 shadow-none flex-grow-1 p-0 m-0"
                  style="outline: none; min-width: 150px; background: transparent; font-size: 14px"
                  placeholder="Type and press Enter or comma to add"
                  (keydown)="addMachineryTag($event, machineryInput)" />
              </div>
              <div *ngIf="
                  registerForm.get('plantMachinery')?.touched &&
                  registerForm.get('plantMachinery')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span>Machinery details are required.</span>
              </div>
            </div>

            <!-- Ash unloading facilities Multi-Select Dropdown -->
            <div class="col-md-6">
              <label class="form-label">Ash Unloading Storage Facilities <span class="required-star">*</span></label>
              <div class="dropdown-wrapper">
                <div class="multi-select-trigger" [class.open]="showUnloadDropdown"
                  (click)="toggleUnloadDropdown(); $event.stopPropagation()">
                  <div class="multi-select-tags">
                    <span *ngIf="getSelectedUnload().length === 0" class="multi-select-placeholder">Select Ash Unload
                      Storage Facilities</span>
                    <span *ngFor="let facility of getSelectedUnload()" class="selection-badge">
                      {{ facility.name }}
                      <i class="bi bi-x-circle-fill" (click)="removeUnload(facility.id); $event.stopPropagation()"></i>
                    </span>
                  </div>
                  <i class="bi bi-chevron-down multi-select-chevron"></i>
                </div>

                <div *ngIf="showUnloadDropdown" class="multi-select-menu" (click)="$event.stopPropagation()">
                  <div *ngIf="unloadLoading" class="multi-select-loading">
                    Loading facilities...
                  </div>
                  <div *ngIf="unloadError" class="multi-select-error">
                    Unable to load facilities. Please refresh.
                  </div>
                  <div *ngFor="let facility of ashUnloadList" class="multi-select-option">
                    <input type="checkbox" [id]="'unload_' + facility.id"
                      [checked]="isUnloadFacilityChecked(facility.id)" (change)="toggleUnloadFacility(facility.id)" />
                    <label [for]="'unload_' + facility.id">{{ facility.name }}</label>
                  </div>
                </div>
              </div>
              <div *ngIf="
                  registerForm.get('ashUnloadingFacilities')?.touched &&
                  registerForm.get('ashUnloadingFacilities')?.invalid
                " class="field-error">
                <i class="bi bi-exclamation-circle"></i>
                <span>At least one ash unloading facility must be selected.</span>
              </div>
            </div>
          </div>

          <!-- Row 2: Product Type & Ash Category side-by-side -->
          <div class="row row-gap g-3 mb-3">
            <div class="col-md-6">
              <label class="form-label">Ash Product Type <span class="required-star">*</span></label>
              <div class="dropdown-wrapper">
                <div class="multi-select-trigger" [class.open]="showProductDropdown"
                  (click)="toggleProductDropdown(); $event.stopPropagation()">
                  <div class="multi-select-tags">
                    <span *ngIf="getSelectedProducts().length === 0" class="multi-select-placeholder">Select Ash Product
                      Type</span>
                    <span *ngFor="let prod of getSelectedProducts()" class="selection-badge">
                      {{ prod.name }}
                      <i class="bi bi-x-circle-fill" (click)="removeProduct(prod.id); $event.stopPropagation()"></i>
                    </span>
                  </div>
                  <i class="bi bi-chevron-down multi-select-chevron"></i>
                </div>

                <div *ngIf="showProductDropdown" class="multi-select-menu" (click)="$event.stopPropagation()">
                  <div *ngFor="let prod of flyAshProducts" class="multi-select-option">
                    <input type="checkbox" [id]="'prod_' + prod.id" [checked]="isFlyAshProductChecked(prod.id)"
                      (change)="toggleFlyAshProduct(prod.id)" />
                    <label [for]="'prod_' + prod.id">{{ prod.name }}</label>
                  </div>
                </div>
              </div>
              <div *ngIf="
                  registerForm.get('productType')?.touched &&
                  registerForm.get('productType')?.invalid
                " class="field-error">
                <i class="bi bi-exclamation-circle"></i>
                <span>At least one ash product type must be selected.</span>
              </div>

              <!-- Capacity Dropdown in Left Column -->
              <div class="mt-3">
                <label class="form-label">Capacity (MT) <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i class="bi bi-truck input-icon"></i>
                  <select class="form-select" formControlName="capacity" style="padding-left: 40px">
                    <option value="" disabled selected>Select Capacity</option>
                    <option value="16">16 MT</option>
                    <option value="22">22 MT</option>
                    <option value="28">28 MT</option>
                    <option value="29">29 MT</option>
                    <option value="40">40 MT</option>
                  </select>
                </div>
                <div *ngIf="
                    registerForm.get('capacity')?.touched && registerForm.get('capacity')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Capacity is required.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <!-- Others Product Description Box moved to Right Column -->
              <div class="mb-3" *ngIf="isOthersProductSelected()">
                <label class="form-label">Other Product Description <span class="required-star">*</span></label>
                <div class="input-wrapper">
                  <i style="top: 12px"></i>
                  <textarea class="form-control" formControlName="productDescription" rows="3"
                    placeholder="Please describe your product type"
                    style="padding-left: 40px; padding-top: 12px"></textarea>
                </div>
                <div *ngIf="
                    registerForm.get('productDescription')?.touched &&
                    registerForm.get('productDescription')?.invalid
                  " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                  <span>Product description is required.</span>
                </div>
              </div>

              <label class="form-label">Ash Category <span class="required-star">*</span></label>
              <div class="table-responsive" style="border-radius: 6px; overflow: hidden; border: 1px solid #e9ecef"
                *ngIf="ashCategoriesList && ashCategoriesList.length > 0">
                <table class="table table-sm table-hover align-middle mb-0" style="background-color: white">
                  <thead style="background-color: #f8f9fa">
                    <tr>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        ASH CATEGORY
                      </th>
                      <th scope="col" style="
                          width: 50%;
                          font-size: 12px;
                          font-weight: 600;
                          color: #495057;
                          border-bottom: 1px solid #dee2e6;
                          padding: 10px 16px;
                        ">
                        Min & Max Load (No. of loads/Quarterly)
                        <div style="
                            color: rgb(122, 204, 28);
                            font-size: 9px;
                            font-weight: 400;
                            margin-top: 2px;
                          ">
                          Issue of the ash is subject to availability
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cat of ashCategoriesList">
                      <td style="padding: 10px 16px; border-bottom: 1px solid #f1f3f5">
                        <div class="form-check d-flex align-items-center mb-0">
                          <input class="form-check-input mt-0 me-2" type="checkbox" [id]="'cat_' + cat.id"
                            [checked]="isAshCategoryChecked(cat.id)" (change)="toggleAshCategory(cat.id)"
                            style="cursor: pointer; width: 18px; height: 18px" />
                          <label class="form-check-label text-secondary mb-0" [for]="'cat_' + cat.id" style="
                              font-size: 13.5px;
                              font-weight: 500;
                              cursor: pointer;
                              padding-left: 4px;
                            ">
                            {{ cat.name }}
                          </label>
                        </div>
                      </td>
                      <td style="padding: 6px 16px; border-bottom: 1px solid #f1f3f5">
                        <ng-container *ngIf="isAshCategoryChecked(cat.id)">
                          <ng-container *ngIf="getCategoryFormGroup(cat.id) as catGroup">
                            <div [formGroup]="catGroup" class="d-flex flex-column gap-2">
                              <div class="d-flex gap-2">
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="minLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="min 1-10" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('minLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('minLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                                <div class="flex-grow-1">
                                  <input type="number" class="form-control" formControlName="maxLoad" oninput="
                                      if (this.value.length > 4)
                                        this.value = this.value.slice(0, 4);
                                    " style="
                                      background-color: #f8f9fa;
                                      height: 36px;
                                      font-size: 13.5px;
                                      padding: 0 10px;
                                    " placeholder="max 10-20" />
                                  <div class="mt-1" style="font-size: 10px; color: #6c757d; font-weight: 500" *ngIf="
                                      catGroup.get('maxLoad')?.value &&
                                      registerForm.get('capacity')?.value
                                    ">
                                    Qty:
                                    {{
                                    (catGroup.get('maxLoad')?.value || 0) *
                                    (registerForm.get('capacity')?.value || 0)
                                    }}
                                    MT
                                  </div>
                                </div>
                              </div>
                              <div *ngIf="catGroup.touched && catGroup.invalid" class="text-danger mt-1"
                                style="font-size: 11.5px; font-weight: 500; line-height: 1.2">
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['required']">Min Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['required']">Max Load is
                                  required.<br /></span>
                                <span *ngIf="catGroup.get('minLoad')?.errors?.['min']">Minimum Load must be at least
                                  1.<br /></span>
                                <span *ngIf="catGroup.get('maxLoad')?.errors?.['min']">Maximum Load must be at least
                                  1.<br /></span>
                                <span *ngIf="
                                    catGroup.get('minLoad')?.errors?.['pattern'] ||
                                    catGroup.get('maxLoad')?.errors?.['pattern']
                                  ">Load must be up to 5 digits.<br /></span>
                                <span *ngIf="catGroup.errors?.['minGreaterThanMax']">Minimum Load should not exceed
                                  Maximum Load.</span>
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div *ngIf="!ashCategoriesList || ashCategoriesList.length === 0" class="text-muted mt-2"
                style="font-size: 13.5px">
                Please select a Ash Product Type first to view ash categories.
              </div>
              <div *ngIf="
                  registerForm.get('ashCategoryDetails')?.touched &&
                  registerForm.get('ashCategoryDetails')?.invalid
                " class="field-error mt-2">
                <i class="bi bi-exclamation-circle"></i>
                <span>At least one ash category must be selected and quantities must be valid.</span>
              </div>
            </div>
          </div>

          <!-- TNPCB CTO Certificate Section (moved from Step 2) -->
          <div class="row row-gap g-3 mt-4" *ngIf="registerForm.get('msmeCertificateType')?.value">
            <div class="col-md-12">
              <div class="section-title d-flex align-items-center gap-2 mb-3"
                style="border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">
                <i class="bi bi-clipboard-check"></i>
                <h3 class="mb-0 fw-semibold text-uppercase" style="font-size: 14px;">TNPCB - CTO Certificate</h3>
              </div>

              <!-- CTO Flow Dropdown from API -->
              <div class="input-wrapper mb-2">
                <i class="bi bi-clipboard-check input-icon"></i>
                <select class="form-select" formControlName="consentToOperate" style="padding-left: 40px"
                  [attr.disabled]="ctoFlowLoading ? true : null">
                  <option value="" disabled selected>
                    {{ ctoFlowLoading ? 'Loading...' : 'Select CTO Category' }}
                  </option>
                  <ng-container *ngIf="ctoFlow.length > 0">
                    <option *ngFor="let item of ctoFlow" [value]="item.name || item.value || item">
                      {{ item.name || item.value || item }}
                    </option>
                  </ng-container>
                  <!-- Fallback options if API returns empty -->
                  <ng-container *ngIf="ctoFlow.length === 0 && !ctoFlowLoading">
                    <option value="Exempted">Exempted</option>
                    <option value="Non-Exempted">Non-Exempted</option>
                  </ng-container>
                </select>
              </div>

              <div *ngIf="ctoFlowError" class="text-warning" style="font-size: 12px; margin-bottom: 8px;">
                <i class="bi bi-exclamation-triangle"></i> Could not load CTO options from server. Using defaults.
              </div>

              <div *ngIf="
                  registerForm.get('consentToOperate')?.touched &&
                  registerForm.get('consentToOperate')?.invalid
                " class="text-danger" style="font-size: 11.5px; margin-top: 4px; font-weight: 500">
                <span *ngIf="registerForm.get('consentToOperate')?.errors?.['required']">CTO Status is required.</span>
              </div>

              <!-- Optional exemption details text -->
              <div class="input-wrapper mt-2" *ngIf="registerForm.get('consentToOperate')?.value === 'Exempted'">
                <i class="bi bi-card-text input-icon"></i>
                <input type="text" class="form-control" formControlName="ctoExemptedDetails"
                  placeholder="Enter CTO Exemption details (Optional)" style="padding-left: 40px" />
              </div>

              <!-- Document Upload — only when Non-Exempted (docTypeId: 24) -->
              <div class="mt-3" *ngIf="registerForm.get('consentToOperate')?.value === 'Non-Exempted'">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles['ctoDocument']"
                  (click)="openUploadPopup('ctoDocument')">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles['ctoDocument']"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles['ctoDocument']"></i>
                    </div>
                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        CTO Document (PCB) <span class="required-star">*</span>
                      </div>
                      <div class="mini-upload-hint" [class.success]="uploadedFiles['ctoDocument']">
                        <span *ngIf="uploadedFiles['ctoDocument']">
                          Uploaded:
                          {{
                          (uploadedFiles['ctoDocument']?.name?.length || 0) > 20
                          ? (uploadedFiles['ctoDocument']?.name | slice: 0 : 18) + '...'
                          : uploadedFiles['ctoDocument']?.name
                          }}
                        </span>
                        <span *ngIf="!uploadedFiles['ctoDocument']">PDF, Image (Max 2MB)</span>
                      </div>
                    </div>
                  </div>
                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles['ctoDocument']"
                    [class.bi-chevron-right]="!uploadedFiles['ctoDocument']"
                    [class.done]="uploadedFiles['ctoDocument']"></i>
                </div>
                <div *ngIf="!uploadedFiles['ctoDocument']" class="text-danger mt-1"
                  style="font-size: 11.5px; font-weight: 500;">
                  TNPCB CTO Certificate is required for Non-Exempted category.
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Step 5: Document Uploads & Declaration (activeStep === 4) -->
        <div class="form-step" *ngIf="activeStep === 4">

          <p class="section-desc">Upload documents</p>

          <!-- Document Upload Cards Grid -->
          <div class="row g-3">
            <ng-container *ngFor="let docKey of Object.keys(docLabels)">
              <div class="col-md-6" *ngIf="
                  docKey !== 'gstCertificate' &&
                  docKey !== 'panCard' &&
                  docKey !== 'ctoDocument' &&
                  docKey !== 'previousEbBill' &&
                  docKey !== 'msmeCertificate' &&
                  docKey !== 'gpsMapCameraPhoto'
                ">
                <div class="mini-upload-card" [class.uploaded]="uploadedFiles[docKey]"
                  (click)="openUploadPopup(docKey)">
                  <div class="mini-upload-left">
                    <div class="mini-upload-icon">
                      <i class="bi" [class.bi-file-earmark-check-fill]="uploadedFiles[docKey]"
                        [class.bi-cloud-arrow-up-fill]="!uploadedFiles[docKey]"></i>
                    </div>
                    <div class="mini-upload-info">
                      <div class="mini-upload-title">
                        {{ docLabels[docKey] }}
                        <span *ngIf="
                            docKey === 'previousEbBill' ||
                            docKey === 'gstr3b' ||
                            docKey === 'landOwnership' ||
                            docKey === 'propertyTax'
                          " class="required-star">*</span>
                      </div>
                      <div class="mini-upload-hint" [class.success]="uploadedFiles[docKey]">
                        <span *ngIf="uploadedFiles[docKey]">
                          Uploaded:
                          {{
                          (uploadedFiles[docKey]?.name?.length || 0) > 20
                          ? (uploadedFiles[docKey]?.name | slice: 0 : 18) + '...'
                          : uploadedFiles[docKey]?.name
                          }}
                        </span>
                        <span *ngIf="!uploadedFiles[docKey]">PDF, Image (Max 2MB)</span>
                      </div>
                    </div>
                  </div>
                  <i class="bi mini-upload-status" [class.bi-check-circle-fill]="uploadedFiles[docKey]"
                    [class.bi-chevron-right]="!uploadedFiles[docKey]" [class.done]="uploadedFiles[docKey]"></i>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="declaration-box">
            <div class="declaration-header">
              <div class="declaration-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
              <h4 class="declaration-title">Declaration & Undertaking</h4>
            </div>
            <div class="declaration-check">
              <input type="checkbox" id="declarationCheck" formControlName="declarationCheck" />
              <label for="declarationCheck" style="text-align: justify">
                I/We hereby declare that the details and information furnished above are true and
                correct to the best of my/our knowledge and belief and I/we undertake to inform you
                of any changes therein, immediately. In case any of the above information is found
                to be false or untrue or misleading or misrepresenting, I/we am/are aware that I/we
                may be held liable for it.
              </label>
            </div>
            <div class="declaration-check" style="margin-top: 12px">
              <input type="checkbox" id="declarationCheck2" formControlName="declarationCheck2" />
              <label for="declarationCheck2" style="text-align: justify">
                I/We hereby declare that ash, if offered to the firm, will be utilized solely for
                eco-friendly purposes as stipulated in the MoEF&CC Notification dated 31.12.2021 and
                other applicable Government rules, including any amendments issued from time to
                time.
              </label>
            </div>
            <div *ngIf="
                registerForm.get('declarationCheck2')?.touched &&
                registerForm.get('declarationCheck2')?.invalid
              " class="field-error" style="margin-top: 8px">
              <i class="bi bi-exclamation-circle"></i>
              <span>You must accept the environmental declaration to proceed.</span>
            </div>
            <div *ngIf="
                registerForm.get('declarationCheck')?.touched &&
                registerForm.get('declarationCheck')?.invalid
              " class="field-error" style="margin-top: 8px">
              <i class="bi bi-exclamation-circle"></i>
              <span>You must accept the declaration to proceed.</span>
            </div>
          </div>
        </div>

        <!-- Step 6: Preview Application (activeStep === 5) -->
        <div class="form-step" *ngIf="activeStep === 5">

          <p class="section-desc">Review your registration details before confirming submission.</p>

          <div class="preview-layout">
            <!-- Section 1: Station and Type -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-house-door-fill me-2"></i>Station & Source Info
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Power Station</div>
                  <div class="preview-value">{{ getStationName() }}</div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Mobile Number</div>
                  <div class="preview-value">+91 {{ registerForm.get('mobileNumber')?.value }}</div>
                </div>
              </div>
            </div>

            <!-- Section 2: Firm Details -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title"><i class="bi bi-building me-2"></i>Firm Details</h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Organization Name</div>
                  <div class="preview-value fw-semibold">
                    {{ registerForm.get('firmName')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Email ID</div>
                  <div class="preview-value">{{ registerForm.get('emailAddress')?.value }}</div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">GST Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('gstNumber')?.value | uppercase }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">PAN Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('panNumber')?.value | uppercase }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">MSME Certificate Type</div>
                  <div class="preview-value">
                    {{ registerForm.get('msmeCertificateType')?.value }}
                  </div>
                </div>
                <div class="col-md-6" *ngIf="registerForm.get('msmeRegistrationNumber')?.value">
                  <div class="preview-label">MSME Registration Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('msmeRegistrationNumber')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">TNEB Service Connection Number</div>
                  <div class="preview-value mono">
                    {{ registerForm.get('tnpgclScNumber')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">TNEB Tariff Category</div>
                  <div class="preview-value">{{ getTariffName() }}</div>
                </div>
                <div class="col-md-12">
                  <div class="preview-label">TNPCB - CTO Certificate</div>
                  <div class="preview-value">
                    {{
                    registerForm.get('consentToOperate')?.value === 'Exempted'
                    ? 'Exempted (' + registerForm.get('ctoExemptedDetails')?.value + ')'
                    : registerForm.get('consentToOperate')?.value
                    }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 3: Address Info -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-geo-alt-fill me-2"></i>Address Information
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Plant Address</div>
                  <div class="preview-value">
                    Door No. {{ registerForm.get('doorNo')?.value }}, Survey Field No.
                    {{ registerForm.get('surveyFieldNo')?.value }},<br />
                    {{ registerForm.get('streetLocation')?.value }}, {{ getVillageName('plant') }},
                    {{ getTalukName('plant') }},<br />
                    {{ getDistrictName('plant') }}, {{ getStateName('plant') }} -
                    {{ registerForm.get('pincode')?.value }}
                  </div>
                  <div class="preview-gps mt-2 text-muted" style="font-size: 12px"
                    *ngIf="registerForm.get('latitude')?.value">
                    <i class="bi bi-compass me-1"></i> GPS:
                    {{ registerForm.get('latitude')?.value }},
                    {{ registerForm.get('longitude')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Company Registered Address</div>
                  <div class="preview-value" *ngIf="registerForm.get('sameAsPlantAddress')?.value">
                    <span class="badge bg-success-subtle text-success border border-success-subtle px-2 py-1">Same as
                      Plant Address</span>
                  </div>
                  <div class="preview-value" *ngIf="!registerForm.get('sameAsPlantAddress')?.value">
                    Door No. {{ registerForm.get('companyDoorNo')?.value }}, Survey Field No.
                    {{ registerForm.get('companySurveyFieldNo')?.value }},<br />
                    {{ registerForm.get('companyStreetLocation')?.value }},
                    {{ getVillageName('company') }}, {{ getTalukName('company') }},<br />
                    {{ getDistrictName('company') }}, {{ getStateName('company') }} -
                    {{ registerForm.get('companyPincode')?.value }}
                  </div>
                  <div class="preview-gps mt-2 text-muted" style="font-size: 12px" *ngIf="
                      !registerForm.get('sameAsPlantAddress')?.value &&
                      registerForm.get('companyLatitude')?.value
                    ">
                    <i class="bi bi-compass me-1"></i> GPS:
                    {{ registerForm.get('companyLatitude')?.value }},
                    {{ registerForm.get('companyLongitude')?.value }}
                  </div>
                </div>
              </div>

              <!-- Maps Row -->
              <div class="row g-3 mt-1">
                <div [ngClass]="registerForm.get('sameAsPlantAddress')?.value ? 'col-12' : 'col-md-6'"
                  *ngIf="registerForm.get('latitude')?.value">
                  <div class="preview-map-section mt-1">
                    <div #previewPlantMapContainer class="location-map-container preview-location-map" role="img"
                      aria-label="Plant location preview map"></div>
                  </div>
                </div>

                <div class="col-md-6"
                  *ngIf="!registerForm.get('sameAsPlantAddress')?.value && registerForm.get('companyLatitude')?.value">
                  <div class="preview-map-section mt-1">
                    <div #previewCompanyMapContainer class="location-map-container preview-location-map" role="img"
                      aria-label="Company location preview map"></div>
                  </div>
                </div>
              </div>
              <div *ngIf="previewMapError" class="text-danger mt-2" style="font-size: 11.5px; font-weight: 500">
                {{ previewMapError }}
              </div>
            </div>

            <!-- Section 4: Plant Operations -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-gear-wide-connected me-2"></i>Plant Operations & Ash Requirements
              </h4>
              <div class="row g-3">
                <div class="col-md-6">
                  <div class="preview-label">Selected Ash Products</div>
                  <div class="preview-value">{{ getProductName() }}</div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Plant Capacity</div>
                  <div class="preview-value">{{ registerForm.get('capacity')?.value }} MT</div>
                </div>
                <div class="col-md-6" *ngIf="isOthersProductSelected()">
                  <div class="preview-label">Other Product Description</div>
                  <div class="preview-value">
                    {{ registerForm.get('productDescription')?.value }}
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Ash Unloading Facilities</div>
                  <div class="preview-value">
                    <span *ngFor="let facility of getSelectedUnload()" class="badge bg-light text-dark border me-1">
                      {{ facility.name }}
                    </span>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="preview-label">Plant & Machinery</div>
                  <div class="preview-value">
                    <span *ngFor="
                        let item of getMachineryList(registerForm.get('plantMachinery')?.value)
                      " class="badge bg-light text-dark border me-1">
                      {{ item }}
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="preview-label mb-2">Requested Ash Categories & Quantities</div>
                  <div class="table-responsive border rounded">
                    <table class="table table-sm table-striped mb-0 align-middle">
                      <thead class="bg-light border-bottom">
                        <tr>
                          <th rowspan="2" class="ps-3 py-2 align-middle border-end border-bottom-0"
                            style="font-size: 12px; width: 30%">
                            Ash Category
                          </th>
                          <th colspan="2" class="py-2 text-center border-bottom border-end" style="font-size: 12px">
                            Loads (Loads/Day)
                          </th>
                          <th colspan="2" class="py-2 text-center border-bottom border-end" style="font-size: 12px">
                            Quantity (MT/Quarterly)
                          </th>
                        </tr>
                        <tr>
                          <th class="py-2 text-center border-end" style="font-size: 12px; width: 17.5%">
                            Min Load
                          </th>
                          <th class="py-2 text-center border-end" style="font-size: 12px; width: 17.5%">
                            Max Load
                          </th>
                          <th class="py-2 text-center border-end" style="font-size: 12px; width: 17.5%">
                            Min Qty
                          </th>
                          <th class="pe-3 py-2 text-center" style="font-size: 12px; width: 17.5%">
                            Max Qty
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let cat of getSelectedCategories()">
                          <td class="ps-3 py-2 fw-medium border-end" style="font-size: 13px">
                            {{ cat.name }}
                          </td>
                          <td class="py-2 text-center border-end" style="font-size: 13px">
                            {{ cat.minLoad }}
                          </td>
                          <td class="py-2 text-center border-end" style="font-size: 13px">
                            {{ cat.maxLoad }}
                          </td>
                          <td class="py-2 text-center border-end" style="font-size: 13px">
                            {{ cat.minQuantity }}
                          </td>
                          <td class="pe-3 py-2 text-center" style="font-size: 13px">
                            {{ cat.maxQuantity }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!-- Section 5: Supporting Documents -->
            <div class="preview-section mb-4">
              <h4 class="preview-section-title">
                <i class="bi bi-file-earmark-arrow-up-fill me-2"></i>Uploaded Documents
              </h4>
              <div class="row g-3">
                <div class="col-md-12">
                  <div class="d-flex flex-wrap gap-2">
                    <ng-container *ngFor="let docKey of Object.keys(docLabels)">
                      <div class="p-2 border rounded d-flex align-items-center justify-content-between bg-white"
                        style="width: calc(50% - 8px); min-width: 280px" *ngIf="uploadedFiles[docKey]">
                        <div class="d-flex align-items-center">
                          <i class="bi bi-file-earmark-check-fill text-success fs-5 me-2"></i>
                          <div>
                            <div class="fw-semibold" style="font-size: 12px; color: #495057">
                              {{ docLabels[docKey] }}
                            </div>
                            <div class="text-muted" style="font-size: 11px">
                              {{ uploadedFiles[docKey]?.name }}
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-primary py-1 px-2"
                          (click)="viewUploadedFile(uploadedFiles[docKey], docKey)">
                          <i class="bi bi-eye"></i> View
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn-cancel" type="button" routerLink="/login" *ngIf="activeStep < 5">
            <i class="bi bi-x-lg"></i> Cancel
          </button>
          <button class="btn-save-draft" type="button" *ngIf="activeStep < 5" (click)="onSaveDraft()"
            [disabled]="isSavingDraft || !canSaveDraft()">
            <span *ngIf="isSavingDraft" class="spinner-border spinner-border-sm me-1" role="status"
              aria-hidden="true"></span>
            <i *ngIf="!isSavingDraft" class="bi bi-save2"></i>
            {{ isSavingDraft ? 'Saving...' : 'Save Draft' }}
          </button>
          <div class="d-flex gap-2 ms-auto w-100 justify-content-between" *ngIf="activeStep === 5">
            <button class="btn-cancel" type="button" (click)="goToPreviousStep()">
              <i class="bi bi-arrow-left"></i> Back to Edit
            </button>
            <button type="button" class="btn-next ms-auto" (click)="submitFromPreview()">
              Confirm & Submit <i class="bi bi-check-circle"></i>
            </button>
          </div>
          <div class="d-flex gap-2 ms-auto" *ngIf="activeStep < 5">
            <button class="btn-cancel" type="button" *ngIf="activeStep > 0" (click)="goToPreviousStep()">
              <i class="bi bi-arrow-left"></i> Previous
            </button>
            <button class="btn-next" type="button" *ngIf="activeStep < 4" (click)="goToNextStep()" [disabled]="
                (activeStep === 0 &&
                  (!mobileOtpVerified || registerForm.get('station')?.invalid)) ||
                (activeStep === 1 && !emailOtpVerified)
              ">
              Next Step <i class="bi bi-arrow-right"></i>
            </button>
            <button class="btn-next" type="button" *ngIf="activeStep === 4" (click)="goToNextStep()">
              Preview Application <i class="bi bi-eye"></i>
            </button>
          </div>
        </div>

        <div class="register-login-link" *ngIf="activeStep < 5">
          Already have an account? <a routerLink="/login">Sign in here</a>
        </div>
      </form>
    </div>
  </main>
</div>

<div *ngIf="activeUploadDocKey" class="upload-modal-backdrop">
  <div class="upload-modal-content">
    <div class="modal-header">
      <h3>Upload {{ docLabels[activeUploadDocKey] }}</h3>
      <button type="button" class="modal-close-btn" (click)="closeUploadPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-upload-zone">
      <i class="bi bi-cloud-arrow-up-fill"></i>
      <div class="zone-title">Drag and drop file here, or click to browse</div>
      <div class="zone-hint" *ngIf="activeUploadDocKey !== 'gpsMapCameraPhoto'">
        Supported formats: PDF, JPEG, PNG (Max 2MB)
      </div>
      <div class="zone-hint" *ngIf="activeUploadDocKey === 'gpsMapCameraPhoto'">
        Supported formats: JPEG, PNG (Max 2MB)
      </div>
      <input type="file" [accept]="
          activeUploadDocKey === 'gpsMapCameraPhoto'
            ? 'image/jpeg, image/png, image/jpg'
            : '.pdf, image/jpeg, image/png, image/jpg'
        " (change)="onModalFileSelected($event)" />
    </div>

    <div *ngIf="selectedFileForUpload" class="selected-file-box">
      <div class="selected-file-info">
        <i class="bi bi-file-earmark-text"></i>
        <span>{{ selectedFileForUpload.name }}</span>
      </div>
      <button type="button" class="file-remove-btn" (click)="selectedFileForUpload = null">
        <i class="bi bi-trash"></i>
      </button>
    </div>

    <div class="modal-actions">
      <button type="button" class="btn-cancel" (click)="closeUploadPopup()">Cancel</button>
      <button type="button" class="btn-next" [disabled]="!selectedFileForUpload || isUploading"
        (click)="confirmUpload()">
        <i class="bi bi-cloud-check-fill" *ngIf="!isUploading"></i>
        <span *ngIf="!isUploading">Confirm Upload</span>
        <span *ngIf="isUploading">Uploading...</span>
      </button>
    </div>
  </div>
</div>

<!-- Document Preview Modal -->
<div class="custom-modal-backdrop" *ngIf="previewDocumentUrl">
  <div class="custom-modal-content"
    style="max-width: 1400px; width: 95%; height: 95vh; display: flex; flex-direction: column">
    <div class="modal-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom bg-light">
      <h3 class="modal-title mb-0 fs-6 fw-bold">
        <i class="bi bi-file-earmark-text text-primary me-2"></i> Document Preview
      </h3>
      <div class="d-flex gap-2">
        <button class="btn btn-sm btn-outline-primary d-flex align-items-center gap-1"
          (click)="downloadPreviewDocument()" title="Download Document">
          <i class="bi bi-download"></i> Download
        </button>
        <button class="btn-close-modal" (click)="closeDocumentPreview()" style="
            background: none;
            border: none;
            font-size: 1.2rem;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            transition: background-color 0.2s;
          " onmouseover="this.style.backgroundColor = '#e9ecef'"
          onmouseout="this.style.backgroundColor = 'transparent'">
          <i class="bi bi-x-lg text-secondary" style="font-size: 1rem"></i>
        </button>
      </div>
    </div>
    <div class="modal-body flex-grow-1 p-0" style="position: relative; background: #525659; overflow: hidden">
      <iframe [src]="previewDocumentUrl" style="width: 100%; height: 100%; border: none; display: block"></iframe>
    </div>
  </div>
</div>